export const getUserData = (state) => state.auth?.userData;
export const getUserType = (state) => getUserData(state)?.type;

export const getAuthUser = (state) => state.auth?.authUser;
